import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import Header from './components/Header';
import Banner from './components/Banner';
import About from './components/About';
import AboutFlavia from './components/AboutFlavia';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Avaliacoes from './components/Avaliacoes';
import FAQ from './components/FAQ';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
    line-height: 1.6;
    color: #333;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <Router>
      <GlobalStyle />
      <AppContainer>
        <Header />
        <MainContent>
          <Banner id="home" />
          <Services id="servicos" />
          <About id="quem-somos" />
          <AboutFlavia />
          <Avaliacoes />
          <FAQ />
          <Contact id="contato" />
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
